import http from "@/services/http";
import httpForm from "@/services/httpForm"

export const itens = () => {
  async function list() {
    const {data} = await http.get('/itens/list');
    return data;
  }

  async function store(itemFormData) {
    const response = await httpForm.post('/itens/store', itemFormData);
    return response.data;
  }

  async function delet(id) {
    await http.put('/itens/delete/'+id,{});
    return true;
  }

  async function update(itemFormData) {
    const response = await httpForm.post('/itens/edit', itemFormData);
    return response.data;
  }

  async function getOne(id) {
    const {data} = await http.get('/itens/getOne/'+id);
    return data;
  }

  async function getByCategory(id) {
    let retorno;
    try {
        const {data} = await http.get('/itens/getByCategory/'+id);
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function getByLink(link) {
    let retorno;
    try {
        const {data} = await http.get('/itens/getOne/'+link);
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function checkDisponibility(id_item, rental_date_start, rental_date_end) {
    let retorno;
    try {
        const {data} = await http.post(`/itens/checkDisponibility`, {
          id_item,
          rental_date_start,
          rental_date_end
        });
        retorno = data;
      } catch (error) {
        return false;
      }
    return retorno;
  }

  // Preço por período: faixas "até X horas = R$ Y"
  async function getPriceRules(id) {
    const {data} = await http.get('/itens/priceRules/'+id);
    return data;
  }

  async function setPriceRules(id, rules) {
    const response = await http.post('/itens/priceRules', { id, rules });
    return response.data;
  }

  return {list, store, delet, update,getOne,getByLink,getByCategory,checkDisponibility,getPriceRules,setPriceRules};
}
